<template>
  <v-img
    :src="backgroundImg"
  >
    <v-container fluid class="mx-0 mb-0 pa-0 mt-5">
      <v-layout row wrap text-xs-center>
        <v-flex xs12 class="mt-5">
          <div class="display-2 black--text" v-text="banner.title"></div>
          <div class="display-1 black--text" v-text="banner.subtitle"></div>
        </v-flex>
        <v-flex xs12>
          <v-container grid-list-lg>
            <v-layout row wrap justify-center class="text-xs-center" mt-5>
              <v-flex xs12 sm12 md4 lg3
                class="mx-3 mb-5 price-card"
                v-for="(plan, i) in plans"
                :key="i"
              >
                <v-card class="py-4"
                  :class="[plan.name === choosed.name ? 'elevation-20' : '']"
                  :color="plan.name === choosed.name ? 'orange' : 'gray'"
                  :dark="plan.name !== choosed.name"
                >
                  <v-card-text class="no-mrpd">
                    <h4 class="display-1">{{ plan.name }}</h4>
                    <p class="subheading">{{ plan.audience }}</p>
                    <div class="cost box-red-300-glow white--text" v-html="plan.cost"></div>
                    <p v-for="(feature, i) in plan.features" :key="i" v-html="feature" class="body-2"></p>
                  </v-card-text>
                  <v-btn color="box-green-a700-glow" @click=" goContact()" dark>{{ plan.action.text }}</v-btn>
                  <p v-html="plan.trial"></p>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>

          <v-layout row wrap text-xs-center>
                      <v-flex xs12 text-xs-center>
                        <div class="display-1 mr--100 ml--100">
                <p >Y si prefieres otro modo de contratación, contacta con nosotros para que te hagamos llegar una propuesta personalizada.</p>
                        </div>
                                        <div class="text-xs-center">
                  <v-btn
                    round
                    color="orange darken-4"
                    dark
                    bold
                    outline
                    @click="goContact()"
                    class="mr-4 elevation-5"
                    >Contactar </v-btn
                  >
                </div>
              </v-flex>
              
 
      </v-layout>
      <v-layout row wrap text-xs-center class="mt-5">
                      <v-flex xs12 text-xs-center>
                <p class="title black--text">Coste en créditos de cada servicio.</p>
              </v-flex>
        <v-flex xs12 text-xs-center class="ml--100 mr--100">
                  <ul >
                    <li>Firma Electrónica : 2 créditos </li>
                    <li>Notificación Certificada  : 1 créditos </li>
                    <li>Video identificación : 3 créditos </li>
                    <li>Análisis y OCR de documentos : 2 créditos </li>
     
                  </ul>
        </v-flex>
      </v-layout>


      <v-layout row wrap>
        <v-flex xs12>
          <v-container grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <h4 class="display-1 black--text">FAQ</h4>
                <p class="title black--text">Resolvemos las dudas más comunes.</p>
              </v-flex>
              <v-flex xs12 sm6
                v-for="(faq, i) in faqs"
                :key="i"

              >
                <v-card class="pa-4">
                  <v-card-title primary-title>
                    <div class="title">
                      <v-icon left>{{ faq.icon }}</v-icon> {{ faq.title }}
                    </div>
                    <div v-html="faq.detail"></div>
                  </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-img>
</template>

<script>
import { rgba as Gradients } from "@/data/gradients";
//import ToolbarSimple from "@/layouts/FullPageSimple/Toolbar";
export default {
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      gradient: Gradients[9],
      backgroundImg: "",
      banner: {
        title: `Empieza hoy mismo`,
        subtitle: `5 Créditos Gratis`,
        description: "Sólo te llevará un minuto."
      },
      plans: [
        {
          name: "Basic 1",
          audience: "Plan Prepago",
          cost: `<span class="display-1"> 10 <sup>€</sup></span> por 20 créditos`,
          features: [
                   "Firma Electrónica",
            "Notificación Certificada ",
            "Video identificación",
            "Análisis y OCR de documentos",
            "Soporte por Email"
          ],
          action: {
            text: "Contactar"
          },
          trial: `<div class="cyan--text"></div>`
        },
        {
          name: "Basic 2" ,
          audience: "Plan Prepago",
          cost: `<span class="display-1"> 20 <sup>€</sup></span> por 50 créditos`,
          features: [
            "Firma Electrónica",
            "Notificación Certificada ",
            "Video identificación",
            "Análisis y OCR de documentos",
            "Soporte por Email"
          ],
          action: {
            text: "Contactar"
          },
          trial: `<div class="cyan--text"></div>`
        },
        {
          name: "Basic 3",
          audience: "Plan Prepago",
          cost: `<span class="display-1"> 100 <sup>€</sup></span> por 300 créditos`,
          features: [
            "Firma Electrónica",
            "Notificación Certificada ",
            "Video identificación",
            "Análisis y OCR de documentos",

            "Soporte por Email"
          ],
          action: {
            text: "Contactar"
          },
          trial: `<div class="cyan--text"></div>`
        },

      ],
      faqs: [

        {
          title: "¿Tienen que pagar los firmantes?",
          icon: "message",
          detail: `No, sólo el que envía los documentos a firmar necesita tener una cuenta de Securryty. Las personas que reciben las peticiones de firma sólo tendrán que abrir el correo y comenzar a firmar.`
        },
        {
          title: "¿Qué es un usuario?",
          icon: "message",
          detail: `Los usuarios son las personas que envían documentos que deben ser firmados usando Securyty. Tienen su propia cuenta, historial y preferencias `
        },
 
        {
          title: "¿Cuales son los modos de pago admitidos?",
          icon: "message",
          detail: `Por el momento  admitimos PayPal y pago poor transferencia `
        }       
      ],
      choosed: {
        name: "Basic 1",
        audience: "For 10 users",
        cost: `<span class="display-1"><sup>$</sup> 12.5</span> monthly per user`,
        features: [
          "2 xxvCPU",
          "2TB Transfer",
          "30GB SSD Disk",
          "30 Projects",
          "60 Boards",
          "24/7 Support"
        ],
        action: {
          text: "Comenzar"
        },
        trial: `<div class="pink--text">$5 credit for new A/C</div>`
      }
    };
  },
  components: {
   // ToolbarSimple
  },
  methods: {
    setPlan(plan) {
      if (plan.audience === 'Prepaid plan') {
        this.$ga.event({
          eventCategory: "PrepaidPlan", // str
          eventAction: "click", // str
          eventLabel: "GetStartedButton", // str
          eventValue: 0 // int
        });
      } else if (plan.audience === 'For small business') {
        this.$ga.event({
          eventCategory: "ForSmallBusiness", // str
          eventAction: "click", // str
          eventLabel: "GetStartedButton", // str
          eventValue: 0 // int
        });
      } else if (plan.audience === 'For unlimited users') {
        this.$ga.event({
          eventCategory: "ForUnlimitedUsers", // str
          eventAction: "click", // str
          eventLabel: "GetStartedButton", // str
          eventValue: 0 // int
        });
      }
      this.choosed = plan;
    },
        goContact() {
      this.$router.push({ name: "ContactPage" });
    },
  }
};
</script>

<style scoped lang="stylus">
  .price-scheme
    margin-top: -140px
  .elevate
    margin-top: -74px
  .cost
    padding: 10px 0
    margin-bottom: 20px
  .price-card
    max-width 320px
</style>
